<template>
  <BaseRoundButton
    is-white
    :is-neutral="getEntitySyncNeutralClass(entitySync.sync)"
    :size="44"
    :icon="getEntitySyncIcon(entitySync.profile, entitySync.sync)"
    :tooltip-text="getEntitySyncTooltip(entitySync.profile, entitySync.sync)"
    @click.native.stop="onSynchronizeClick"
  />
</template>

<script>
import BaseRoundButton from '@/components/base/BaseRoundButton.vue';
import { getEntitySyncIcon, getEntitySyncTooltip, getEntitySyncNeutralClass } from '@/util/entity-sync-util';

export default {
  name: 'BaseEntitySync',
  components: {
    BaseRoundButton,
  },
  props: {
    entitySync: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getEntitySyncTooltip,
    getEntitySyncIcon,
    getEntitySyncNeutralClass,
    onSynchronizeClick() {
      this.$emit('synchronize', this.entitySync);
    },
  },
};
</script>

<style lang="scss"></style>
